import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled } from '@mui/system';

const Title = styled(DialogTitle)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.primary.dark,
}));

const StyledDialog = styled(Dialog)(() => ({
  '.MuiDialog-paper': {
    margin: 'auto',
    maxWidth: '360px',
  },
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: '10px 24px 24px 24px',
  color: theme.palette.primary.dark,
  fontSize: 14,
}));

const StyledDialogActions = styled(DialogActions)(() => ({
  padding: 0,
  margin: '12px 12px 12px 0',
  '& > .MuiButton-root': {
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: 'rgba(30, 192, 217, 0.1)',
    },
  },
}));

export const TMO_NOTICE_FALLBACK_MESSAGE = 'Please contact the TMO to cancel the trip.';

export const formatTmoPhoneNumber = tmoPhoneNumber => {
  const trimmed = `${tmoPhoneNumber ?? ''}`.trim();
  const digits = trimmed.replace(/\D/g, '');

  return digits.length === 10 ? digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : trimmed;
};

export const tmoNoticeMessage = tmoPhoneNumber => {
  const formatted = formatTmoPhoneNumber(tmoPhoneNumber);

  return formatted.length > 0
    ? `Please contact the TMO (${formatted}) to cancel the trip.`
    : TMO_NOTICE_FALLBACK_MESSAGE;
};

const TmoNoticeDialog = ({ open, tmoPhoneNumber, onClose }) => (
  <StyledDialog
    open={open}
    onClose={(event, reason) => {
      if (reason === 'backdropClick') return;
      onClose();
    }}
    disableEscapeKeyDown
    role="dialog"
    aria-modal="true"
    aria-labelledby="tmo-notice-dialog-title"
    aria-describedby="tmo-notice-dialog-content"
  >
    <Title id="tmo-notice-dialog-title">Cancel Trip</Title>
    <StyledDialogContent id="tmo-notice-dialog-content">{tmoNoticeMessage(tmoPhoneNumber)}</StyledDialogContent>
    <StyledDialogActions>
      <Button id="tmo-notice-dialog-ok" onClick={() => onClose()} color="secondary">
        OK
      </Button>
    </StyledDialogActions>
  </StyledDialog>
);

TmoNoticeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  tmoPhoneNumber: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

TmoNoticeDialog.defaultProps = {
  tmoPhoneNumber: null,
};

export default TmoNoticeDialog;
